const Story = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.0005 16.6666H17.5005"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7505 2.91669C14.082 2.58517 14.5316 2.39893 15.0005 2.39893C15.2326 2.39893 15.4625 2.44465 15.677 2.53349C15.8915 2.62233 16.0863 2.75254 16.2505 2.91669C16.4146 3.08084 16.5449 3.27572 16.6337 3.4902C16.7225 3.70467 16.7683 3.93455 16.7683 4.16669C16.7683 4.39884 16.7225 4.62871 16.6337 4.84319C16.5449 5.05766 16.4146 5.25254 16.2505 5.41669L5.83382 15.8334L2.50049 16.6667L3.33382 13.3334L13.7505 2.91669Z"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Story;
